import { baseApi } from "@shared/api/baseApi"; // Import shared baseApi
import { UserInfo } from "../model/types";

interface CS2Stats {
  bet_profit: string;
  hot_task_profit: string;
  prize_amount: string;
}

interface TradeLinkResponse {
  success: boolean;
  message: string;
}

export const userInfoApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getUserInfo: builder.query<UserInfo, void>({
      query: () => ({
        url: "users/me", // Relative path
        method: "POST",
      }),
    }),
    getCS2Stats: builder.query<CS2Stats, void>({
      query: () => ({
        url: "cs2/stats", // Relative path
        method: "GET",
      }),
    }),
    getUserAvatarAndNickname: builder.query<UserInfo, string>({
      query: (userId) => `user/${userId}`, // Relative path
    }),
    submitTradeLink: builder.mutation<TradeLinkResponse, string>({
      query: (tradelink) => ({
        url: "/user/tradelink",
        method: "POST",
        body: { tradelink },
      }),
    }),
  }),
});

export const { 
  useGetUserInfoQuery,
  useGetUserAvatarAndNicknameQuery,
  useGetCS2StatsQuery,
  useSubmitTradeLinkMutation,
  useLazyGetUserInfoQuery,
} = userInfoApi;
